import { MMButton } from '@components/index'
import cn from '@integrations/classnames'
import { toast } from '@integrations/notifications'
import type { ReactNode } from '@integrations/react'
import { useCurrencies } from 'mmfintech-backend-api'
import { copyTextToClipboard, formatMoney, tr } from 'mmfintech-commons'

import styles from './LabelValue.module.scss'

interface Props {
  label: string
  value?: ReactNode
  amount?: number
  currency?: string
  dataTest?: string
  enableCopy?: boolean
  valueClass?: string
  labelClass?: string
  containerClass?: string
}

function LabelValue({
  label,
  value = '',
  amount,
  currency,
  dataTest,
  enableCopy = false,
  valueClass,
  labelClass,
  containerClass
}: Props) {
  const { getCurrencyPrecision } = useCurrencies()

  function handleCopyClick() {
    copyTextToClipboard(String(value))
    toast.remove()
    toast.success(tr('FRONTEND.BANKING.COMMON.COPY_SUCCESS', 'Value copied to clipboard.'))
  }

  if (value) {
    return (
      <div className={cn(styles['label-value-wrapper'], 'label-value-wrapper', 'row', containerClass)}>
        <div className={cn(styles['label'], 'label')}>{label}</div>
        {enableCopy ? (
          <div className={cn(styles['copy-box'], 'copy-box')}>
            <span data-test={dataTest}>{value}</span>
            <MMButton
              type='button'
              variant='primary'
              caption={tr('FRONTEND.BUTTONS.COPY', 'Copy')}
              onClick={handleCopyClick}
            />
          </div>
        ) : (
          <div className={cn(styles['value'], 'value', valueClass)} data-test={dataTest}>
            {value}
          </div>
        )}
      </div>
    )
  }

  if (amount > 0 && currency?.length) {
    return (
      <div className={cn(styles['label-value-wrapper'], 'label-value-wrapper', 'row', containerClass)}>
        <div className={cn(styles['label'], 'label', labelClass)}>{label}</div>
        <div className={cn(styles['value'], 'value', valueClass)} data-test={dataTest}>
          {formatMoney(amount, currency, getCurrencyPrecision(currency))}
        </div>
      </div>
    )
  }

  return null
}

export default LabelValue
